import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions} from "../../../../utils/formatar";

@inject("store")
@observer
export class DetalhamentoSolicitante extends Component {

    static propTypes = {
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const solicitacaoMudancaPrazo = this.props.controller.solicitacaoMudancaPrazo;
        const solicitacaoProrrogacao = this.props.controller.solicitacaoProrrogacao;
        const exibeGestorSolicitante = this.props.controller.exibeGestorSolicitante;
        const exibeSolicitanteMudancaPrazo = this.props.controller.exibeSolicitanteMudancaPrazo;
        const exibirGestorSolicitante = this.props.controller.exibirGestorSolicitante;
        const exibeSolicitanteProrrogacao = this.props.controller.exibeSolicitanteProrrogacao;
        return (
            <div>
                <h4>Solicitante</h4>
                <Row>
                    {exibeSolicitanteMudancaPrazo ? (
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nome do solicitante</Label>
                                <Input type="text" value={_.get(solicitacaoMudancaPrazo, "usuarioSolicitante.nome", "")} readOnly />
                            </FormGroup>
                        </Col>
                    ) : (
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Nome do solicitante</Label>
                                <Input type="text" value={_.get(solicitacao, "usuarioSolicitante.nome")} readOnly />
                            </FormGroup>
                        </Col>
                    )}
                    {exibeGestorSolicitante &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <div>
                                <Label>Gestor solicitante</Label>
                                <Input type="text" value={exibirGestorSolicitante} readOnly />
                            </div>
                        </FormGroup>
                    </Col>
                    }
                    {exibeGestorSolicitante &&
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Centro de custo - gestor solicitante</Label>
                            <Input type="text" value={_.get(solicitacao, "centroCustoGestor")} readOnly/>
                        </FormGroup>
                    </Col>
                    }
                </Row>
                {exibeGestorSolicitante &&
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N1</Label>
                            <Input type="text" value={_.get(solicitacao, "nomeAreaResponsavel")} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N2</Label>
                            <Input type="text" value={_.get(solicitacao, "nomeCentral")} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N3</Label>
                            <Input type="text" value={_.get(solicitacao, "nomeDivisao")} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>N4</Label>
                            <Input type="text" value={_.get(solicitacao, "nomeDepartamento")}
                                   readOnly/>
                        </FormGroup>
                    </Col>
                </Row>
                }
            </div>
        )
    }
}